import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface Pin{
  prio:boolean;
  topic:string;
  source:PinSource;
  agentId:string;
  content:string;
  mainTag: string;
  session:string;
  agentName:string;
  dateCreated:number;
}

export enum PinSource{
  SIMPLECHAT= "SIMPLE-CHAT",
  MANUALLYADDED = "MANUALLY-ADDED"
}


@Component({
  selector: 'rr-pin',
  standalone: false,
  templateUrl: './pin.component.html',
  styleUrl: './pin.component.scss'
})
export class PinComponent {
  priorized = false;
  @Input() pin: any;
  @Output() delete = new EventEmitter<any>();
  @Output() priorize = new EventEmitter<any>();
  @Output() depriorize = new EventEmitter<any>();
  @Output() edit = new EventEmitter<any>();

  priorizeClick(pin: any) {
    if(this.priorized) {
      this.priorize.emit(pin);
      this.priorized = false;
    } else {
      this.depriorize.emit(pin);
      this.priorized = true;
    }
  }

  openMenue() { }

}

